// export const baseURL = 'http://localhost:8080/api/v1';
export const baseURL = 'https://node.baseline11.com/api/v1';

export const BasicMonthly = 'price_1OdBAJSFpZ2yZVOD2OWrD01k';
export const BasicYearly = 'price_1OdCKUSFpZ2yZVODiD5SGWME';
export const PremiumMonthly = 'price_1OdC7sSFpZ2yZVODzCJgElU3';
export const PremiumYearly = 'price_1OdCPCSFpZ2yZVODMTc1eSFB';
export const EnterpriseMonthly = 'price_1OdCHXSFpZ2yZVODnPg2tIVI';
export const EnterpriseYearly = 'price_1OdCXUSFpZ2yZVODlQ8Lgi7D';

export const emailRegex =
  /^(?=.{1,254}$)(?=.{1,64}@)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;

export const PaddleConfig = {
  clientToken: 'live_8ee0bb5db14a06479f3d9d938c8',
  prices: {
    Enterprise: {
      month: 'pri_01k4t9pw75pe6ad7f5t1mc14d2',
      year: 'pri_01k4t9nzyfgcx0e3d8rvg5bbsr',
    },
    Premium: {
      month: 'pri_01k4t9mqzya1q27qjkec4x3yt1',
      year: 'pri_01k4t9m7v4ekhtgnsfb5ss4rqw',
    },
    Basic: {
      month: 'pri_01k4t9jgdtcargbebhbkedrdgs',
      year: 'pri_01k4t9hzc35939rgcysdrn127z',
    },
    Free: {
      month: 'pri_01k4t9f98a6g1xxmnnksb7sf4j',
      year: 'pri_01k4t9f98a6g1xxmnnksb7sf4j',
    },
  },
};
